import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, PageGen } from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil, safeBase64Encode } from '../../pdf/gutil';
import { IItemCount, AR_URL } from '@educraft/base';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/barcode';
import '../../pdf/draw/cut';

export class AR implements ILayoutLabelTextGen, IItemCount {
  countMin(): number {
    return 2;
  }
  countDefault(): number {
    return 10;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const pageWidth = PdfSize.A4.width;
    const pageHeight = PdfSize.A4.height;
    const halfHeight = pageHeight / 2;
    const size = pageWidth / 4;

    const pageCount = Math.ceil(opts.list.length / 2);

    const pages: PageGen[] = [];
    for (let i = 0; i < pageCount; i++) {
      pages.push(pdf.addPage(false));
    }

    for (let i = 0; i < opts.list.length; i++) {
      const pageIndex = Math.floor(i / 2);
      const isTop = i % 2 === 0;
      const page = pages[pageIndex];

      const rect = new PdfRect(
        margin,
        margin + (isTop ? 0 : halfHeight),
        pageWidth - 2 * margin,
        halfHeight - 2 * margin
      );

      if (isTop) {
        page.cutCross(new PdfPoint(pageWidth / 2, halfHeight), true, false);
      }

      const text = opts.list[i].text || '';
      const safeBase64 = safeBase64Encode(text);
      const urlBase = (AR_URL || 'https://ar.beil.cz/').replace(/\/$/, '');
      const url = `${urlBase}?text=${safeBase64}`;

      const r1 = new PdfRect(rect.x + rect.width - size, rect.y, size, size);
      const r2 = new PdfRect(
        rect.x + rect.width / 2 - size / 2,
        rect.y + rect.height / 2 - size / 2,
        size,
        size
      );
      const r3 = new PdfRect(rect.x, rect.y + rect.height - size, size, size);

      const label = opts.list[i].label as any;
      if (label) {
        page.drawLabel(label, { rect: r1 });
      }

      page.drawArBarcode(r2, PdfBrush.Black, 0);

      page.drawQr(r3, PdfBrush.Black, url);
    }
  }
}
